module.exports = __webpack_public_path__ + "static/img/ftwo.9da6316.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/match/ftwo.png
// module id = IgQZ
// module chunks = 10